
export default function BulletinsTableFilters(props) {

  const {
    categories,
    sortFields,
    sortField,
    setSortField,
    sortDir,
    setSortDir,
    filters,
    setFilters,
  } = props;

  const handleCategoryChange = (e) => {
    setFilters({
      ...filters,
      category: e.target.value === 'all' ? null : e.target.value
    })
  }

  const handleStatusChange = (e) => {
    setFilters({
      ...filters,
      status: e.target.value === 'all' ? null : e.target.value
    })
  }

  return (
    <div
      className={'block flex-row bulletins-filter-bar'}>

      {categories &&
        <label>
          Category:
          <select
            name="category-filter"
            id="category-filter"
            value={filters?.category || 'all'}
            onChange={handleCategoryChange}
          >
            <option
              value={'all'}>All
              Categories
            </option>
            {categories.map(cat =>
              <option
                key={cat}
                value={cat}>{cat}</option>)}
          </select>
        </label>
      }

      <label>
        Bulletin Status:
        <select
          name="status-filter"
          id="status-filter"
          value={filters?.status || 'all'}
          onChange={handleStatusChange}
        >
          <option value={'all'}>All</option>
          <option value={'active'}>Active</option>
          <option value={'archived'}>Archived</option>
        </select>
      </label>

      {sortFields &&
        <label>
          Sort by:
          <select
            name="sort-field"
            id="sort-field"
            defaultValue={sortField || ''}
            onChange={(e) => setSortField(e.target.value)}
          >
            <option
              value={''}
              disabled>–
            </option>
            {Object.keys(sortFields).map(sort =>
              <option
                key={sortFields[sort].field}
                value={sortFields[sort].field}>{sortFields[sort].label}</option>)}
          </select>
          <select
            name="sort-dir"
            id="sort-dir"
            defaultValue={sortDir || ''}
            onChange={(e) => setSortDir(e.target.value)}
          >
            <option
              value={''}
              disabled>–
            </option>
            <option
              value={'ASC'}>ASC
            </option>
            <option
              value={'DESC'}>DESC
            </option>
          </select>

        </label>
      }

    </div>
  );
}